import { IMAGES, Grain } from "./shared";

const frames = [
  {
    id: "craft-espresso",
    img: IMAGES.craftEspresso,
    alt: "Barista pouring fine latte art onto a ceramic cup",
    tag: "01 / Barista Craft",
    title: "Steam & Precision",
    text: "Dialled-in roasts poured with patience and care.",
  },
  {
    id: "retro-arcade",
    img: IMAGES.retroArcade,
    alt: "Super Nintendo (SNES) system controller",
    tag: "02 / SNES System",
    title: "Video Game Systems",
    text: "CRT monitors, dual stick brawlers, and high-score ladders.",
  },
  {
    id: "inclusive-team",
    img: IMAGES.inclusiveTeam,
    alt: "Smiling team members working together behind the counter",
    tag: "03 / Inclusive Crew",
    title: "Empowered Work",
    text: "Meaningful employment, warm smiles and community first.",
  },
];

const Frame = ({ frame }) => (
  <div
    data-testid={`gallery-frame-${frame.id}`}
    className="relative rounded-2xl overflow-hidden aspect-[4/5] p-6 flex flex-col justify-between group bg-[#1a0f0b]"
  >
    <img
      src={frame.img}
      alt={frame.alt}
      loading="lazy"
      className="card-img absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#120B07]/90 via-[#120B07]/25 to-[#120B07]/30" />
    <Grain id={`g-${frame.id}`} />
    <span className="relative z-10 mono-lbl text-xs uppercase px-3 py-1 bg-white/20 backdrop-blur rounded-full text-white w-max">
      {frame.tag}
    </span>
    <div className="relative z-10 text-white">
      <h3 className="font-bold text-xl mb-1">{frame.title}</h3>
      <p className="text-xs text-white/80">{frame.text}</p>
    </div>
  </div>
);

export const Gallery = () => (
  <section data-testid="experience-section" className="py-20 md:py-28 px-6 md:px-12 max-w-6xl mx-auto">
    <div className="flex flex-col md:flex-row justify-between items-baseline mb-12">
      <div>
        <span className="mono-lbl text-xs text-[#FF2E88] uppercase font-bold">The Experience</span>
        <h2 className="display-type text-3xl md:text-5xl font-bold uppercase mt-2">
          Coffee, Video Game Systems &amp; Therapy Dogs
        </h2>
        <p data-testid="owners-line" className="text-sm text-[#C9BEDC] font-semibold mt-3">
          Run by owners Jonathan Rushmore &amp; Dee Pino
        </p>
      </div>
      <p className="text-sm text-[#A08FB8] max-w-xs mt-3 md:mt-0">
        Free play with any drink purchase. Everyone belongs at our controls.
      </p>
    </div>
    <div className="grid md:grid-cols-3 gap-6">
      {frames.map((f) => (
        <Frame key={f.id} frame={f} />
      ))}
    </div>
  </section>
);
